export const version = '6.5-beta.1737';
